/*
 * @Description:
 * @Date: 2024-12-13 17:06:19
 */
import { useInputColumn, useDatePickerColumn } from 'xrk-components';

/** 项目订单编号 */
export const projectOrderNoSearch = useInputColumn({
  prop: 'projectOrderNo',
  type: 'input',
  label: '项目订单编号',
  config: {
    placeholder: '请输入'
  }
});

/** 个体工商户名称 */
export const individualNameSearch = useInputColumn({
  prop: 'individualName',
  type: 'input',
  label: '个体工商户名称',
  config: {
    placeholder: '请输入'
  }
});

/** 终端服务人员 */
export const fullNameSearch = useInputColumn({
  prop: 'userName',
  type: 'input',
  label: '终端服务人员',
  config: {
    placeholder: '请输入'
  }
});

/** 手机号 */
export const phoneSearch = useInputColumn({
  label: '手机号',
  prop: 'phone',
  type: 'input',
  config: {
    type: 'tel',
    placeholder: '请输入手机号'
  }
});

/** 项目名称 */
export const projectNameSearch = useInputColumn({
  prop: 'projectName',
  type: 'input',
  label: '项目名称',
  config: {
    placeholder: '请输入'
  }
});

/** 项目编码 */
export const projectNoSearch = useInputColumn({
  prop: 'projectCode',
  type: 'input',
  label: '项目编码',
  config: {
    placeholder: '请输入'
  }
});

/** 工业名称 */
export const entpNameSearch = useInputColumn({
  prop: 'industryName',
  type: 'input',
  label: '工业名称',
  config: {
    placeholder: '请输入'
  }
});

/** 服务商税款预扣时间 */
export const aspDeductionTimeSearch = useDatePickerColumn({
  prop: 'aspDeductionTime',
  label: '服务商税款预扣时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange',
    startPlaceholder: '开始时间',
    endPlaceholder: '结束时间'
  },
  listener: {
    onChange: (activeValue, searchValue) => {
      const [aspDeductionTimeStart, aspDeductionTimeEnd] = activeValue || [
        undefined,
        undefined
      ];
      searchValue.aspDeductionTimeStart = aspDeductionTimeStart;
      searchValue.aspDeductionTimeEnd = aspDeductionTimeEnd;
    }
  }
});

/** 终端到账时间 */
export const terminalAccountTimeSearch = useDatePickerColumn({
  prop: 'terminalAccountTime',
  label: '终端到账时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange',
    startPlaceholder: '开始时间',
    endPlaceholder: '结束时间'
  },
  listener: {
    onChange: (activeValue, searchValue) => {
      const [terminalAccountTimeStart, terminalAccountTimeEnd] =
        activeValue || [undefined, undefined];
      searchValue.terminalAccountTimeStart = terminalAccountTimeStart;
      searchValue.terminalAccountTimeEnd = terminalAccountTimeEnd;
    }
  }
});
